import { Component, Inject, Input } from '@angular/core';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';

import { Logger, Option } from '@contact/upgrade';

@Component({
  selector: 'history-mail-panel-info',
  templateUrl: './history-mail-panel-info.component.html',
  styleUrls: ['./history-mail-panel-info.component.scss'],
})
export class HistoryMailPanelInfoComponent {
  @Input() public currentMailSender: string;
  @Input() public currentMailRecipient: string;
  @Input() public currentMailccRecipient: string;
  @Input() public currentMailBccRecipient: string;
  @Input() public currentMailSubject: string;
  @Input() public currentMailResquetId: string;

  constructor(public readonly logger: Logger, @Inject(I18NEXT_SERVICE) public $i18next: ITranslationService) {
    this.logger = this.logger.forSource('HistoryMailPanelInfoComponent');
  }

  extractMail(email: string): string {
    let regex = /\b([^\s]+@[^\s]+)\b/g;
    let recupEmail: string = '';
    email.match(regex)!.forEach(element => {
      if (element.includes('lt')) {
        recupEmail = recupEmail + element.slice(3, element.length - 3).trim() + ' ';
      } else {
        recupEmail = recupEmail + element + ' ';
      }
    });

    return recupEmail;
  }

  isEmpty(value: string | null | undefined): boolean {
    return Option.of(value)
      .filter(v => v !== '')
      .isEmpty();
  }
}
